import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiState {
  sidebarCollapsed: boolean;
  theme: 'light' | 'dark';
  activeBranchId: string | null;
  /** Mobile/tablet drawer (sidebar shown as a Sheet). Not persisted. */
  mobileDrawerOpen: boolean;
  toggleSidebar: () => void;
  setTheme: (t: 'light' | 'dark') => void;
  setActiveBranch: (id: string | null) => void;
  setMobileDrawer: (open: boolean) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      theme: 'light',
      activeBranchId: null,
      mobileDrawerOpen: false,
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setTheme: (theme) => {
        document.documentElement.classList.toggle('dark', theme === 'dark');
        set({ theme });
      },
      setActiveBranch: (activeBranchId) => set({ activeBranchId }),
      setMobileDrawer: (mobileDrawerOpen) => set({ mobileDrawerOpen }),
    }),
    {
      name: 'groomingpro-ui',
      partialize: (s) => ({
        sidebarCollapsed: s.sidebarCollapsed,
        theme: s.theme,
        activeBranchId: s.activeBranchId,
      }),
    },
  ),
);
